import React from 'react';
import { InfoOutline } from '@yme/assets/icons';
import { ICON_SIZE } from '@yme/atoms/svg-icon';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { DisclaimerIconStyled } from './styled';
export const PriceDisclaimerText = ({ campaignDisclaimer }) => {
    if (!campaignDisclaimer) {
        return null;
    }
    return (React.createElement(FlexWrapper, { isFullWidth: true, gap: "8px", alignItems: "flex-start" },
        React.createElement(DisclaimerIconStyled, { type: InfoOutline, pathFill: colorCoreBlack900Base, size: ICON_SIZE.xs }),
        React.createElement(RegularTextLevel4, { color: colorCoreBlack900Base }, campaignDisclaimer)));
};
